export const isValidURL = (url: any): boolean => {
  // Return false if url is not a string
  if (typeof url !== 'string') {
    return false;
  }

  const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  // If URL doesn't have protocol, add https:// prefix
  const urlWithProtocol = url.match(/^(https?|ftp):\/\//)
    ? url
    : `https://${url}`;
  return urlRegex.test(urlWithProtocol);
};
